var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 136,
    viewBox: "0 0 180 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 64,
    r: 64,
    fill: "#E9D7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 6,
    fill: "#F4EBFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 112,
    r: 8,
    fill: "#F4EBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 36,
    r: 8,
    fill: "#F4EBFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 9,
    r: 5,
    fill: "#F4EBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_780_41627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 16C78.534 16 66.6222 22.6541 59.3733 32.8536C57.0062 32.2954 54.5376 32 52 32C34.3269 32 20 46.3269 20 64C20 81.6731 34.3269 96 52 96H132C147.464 96 160 83.464 160 68C160 52.536 147.464 40 132 40C130.902 40 129.818 40.0633 128.752 40.1863C122.623 25.9596 108.475 16 92 16Z",
    fill: "#F9F5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 64,
    r: 32,
    fill: "url(#paint0_linear_780_41627)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 56,
    r: 40,
    fill: "url(#paint1_linear_780_41627)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 68,
    r: 28,
    fill: "url(#paint2_linear_780_41627)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_780_41627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 60,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#6941C6",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 98.5L96.4168 94.4167M99.3333 87.4167C99.3333 92.8935 94.8935 97.3333 89.4167 97.3333C83.9398 97.3333 79.5 92.8935 79.5 87.4167C79.5 81.9398 83.9398 77.5 89.4167 77.5C94.8935 77.5 99.3333 81.9398 99.3333 87.4167Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_780_41627",
    x: 0,
    y: 16,
    width: 180,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_780_41627"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_780_41627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_780_41627"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_780_41627",
    result: "effect2_dropShadow_780_41627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_780_41627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_780_41627",
    x: 54,
    y: 52,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_780_41627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_780_41627",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_780_41627",
    x1: 27.4286,
    y1: 42.8571,
    x2: 84,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_780_41627",
    x1: 61.2857,
    y1: 29.5714,
    x2: 132,
    y2: 95.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_780_41627",
    x1: 110.5,
    y1: 49.5,
    x2: 160,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9D7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIcon);
export default __webpack_public_path__ + "static/media/empty_state_icon.765c4267e43dda84963c7cb4d11a8b64.svg";
export { ForwardRef as ReactComponent };